export default function Footer(){
    return (
        <footer className="footer">
            <div className="footer-socials">
                <a href="https://x.com/Universedle" target="_blank" rel="noopener noreferrer" className="socialmedia-icon">
                    <img src="/assets/x-logo.png" alt="X Logo" className="social-icon"/>
                </a>
            </div>
            <div className="footer-info">
                <p>&copy; 2026 Phasmodle</p>
                <p>Part of Universedle</p>
            </div>
        </footer>
    )
}